var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Partners, { PartnerType } from "../Partners";
import Text from "../Text";
import { Col, Row } from "../grid";
import React from 'react';
import { styled } from "../../utils";
var PaymentPartners = styled(Partners)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && img {\n    height: 22px;\n  }\n"], ["\n  && img {\n    height: 22px;\n  }\n"])));
var BusinessPartners = styled(Partners)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && img {\n    height: 50px;\n  }\n"], ["\n  && img {\n    height: 50px;\n  }\n"])));
var IconsBanner = function (_a) {
    var _b = _a.businessPartners, businessPartners = _b === void 0 ? [] : _b, businessPartnersTitle = _a.businessPartnersTitle, _c = _a.paymentPartners, paymentPartners = _c === void 0 ? [] : _c, paymentPartnersTitle = _a.paymentPartnersTitle;
    return (React.createElement(Row, { "data-component": "IconsBanner", flexWrap: "wrap", my: 2 },
        React.createElement(Col, { px: 0, my: 1, width: [1, 2 / 3] },
            React.createElement(Text, { textAlign: ['center', 'left'] }, paymentPartnersTitle),
            React.createElement(PaymentPartners, { partners: paymentPartners, justifyContent: ['center', 'flex-start'] })),
        React.createElement(Col, { px: 0, my: 1, width: [1, 1 / 3] },
            React.createElement(Text, { textAlign: ['center', 'right'] }, businessPartnersTitle),
            React.createElement(BusinessPartners, { partners: businessPartners, justifyContent: ['center', 'flex-end'] }))));
};
export default IconsBanner;
var templateObject_1, templateObject_2;
//# sourceMappingURL=IconsBanner.js.map